function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import whitelistService from '@/apps/data-platform/services/master_data/whitelist_service';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import router from '@/routes';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
export default _defineProperty(_defineProperty({
  components: {
    DialogsComponent: DialogsComponent,
    PaginationVue: PaginationVue,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      whitelists: [],
      DIALOG_WHITELIST: "dialog_domain",
      DIALOG_ROUTER: "dialog_router",
      DIALOG_WHITELIST_AD: "dialog_domain_ad",
      whitelist_aux: [],
      whitelist_ad_aux: [],
      router_aux: [],
      selectOrganization: [],
      pagination_1: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      pagination_2: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      pagination_3: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      router_sessions: [],
      tab: 0,
      list_orgs: [],
      filter_enabled: true,
      collapse_filter: false,
      filters: {},
      select_whitelist: [],
      whitelist_to_filters: [],
      select_whitelist_ad: [],
      whitelist_to_filters_ad: [],
      router_sessions_to_filters: [],
      ads_list: [{
        value: "AZURE",
        text: "Azure AD"
      }, {
        value: "GOOGLE",
        text: "Google"
      }],
      edit_whitelist: false
    };
  },
  created: function created() {
    this.getOrganizations();
    this.getRouter();
    this.getWhitelist();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      var _this = this;
      if (this.tab == 2) {
        this.select_whitelist_ad = Object.assign([], this.whitelist_to_filters_ad);
        if (this.filters.email) {
          this.select_whitelist_ad = this.select_whitelist_ad.filter(function (x) {
            return x.email.toUpperCase().indexOf(_this.filters.email.toUpperCase()) != -1;
          });
        }
        if (this.filters.ad) {
          this.select_whitelist_ad = this.select_whitelist_ad.filter(function (x) {
            return x.ad.toUpperCase().indexOf(_this.filters.ad.toUpperCase()) != -1;
          });
        }
        return;
      }
      this.select_whitelist = Object.assign([], this.whitelist_to_filters);
      if (this.filters.email) {
        this.select_whitelist = this.select_whitelist.filter(function (x) {
          return x.email.toUpperCase().indexOf(_this.filters.email.toUpperCase()) != -1;
        });
      }
      if (this.filters.domain) {
        this.select_whitelist = this.select_whitelist.filter(function (x) {
          return x.domain.toUpperCase().indexOf(_this.filters.domain.toUpperCase()) != -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.resetFilters();
      if (this.tab == 2) {
        this.select_whitelist_ad = Object.assign([], this.whitelist_to_filters_ad);
      } else {
        this.select_whitelist = Object.assign([], this.whitelist_to_filters);
      }
    },
    resetFilters: function resetFilters() {
      this.filters = {};
    },
    getWhitelist: function getWhitelist() {
      var _this2 = this;
      whitelistService.get_all().then(function (response) {
        _this2.select_whitelist = response.data;
        _this2.whitelist_to_filters = response.data;
        _this2.pagination_1.total = response.data.length;
        _this2.currentPage = 1;
        console.log("orgs", _this2.whitelists);
      });
    },
    getWhitelistAd: function getWhitelistAd() {
      var _this3 = this;
      whitelistService.get_all_ad().then(function (response) {
        _this3.select_whitelist_ad = response.data;
        _this3.whitelist_to_filters_ad = Object.assign([], response.data);
        _this3.pagination_3.total = response.data.length;
        _this3.currentPage = 1;
      });
    },
    getRouter: function getRouter() {
      var _this4 = this;
      whitelistService.get_router().then(function (response) {
        _this4.router_sessions = response.data;
        _this4.pagination_2.total = response.data.length;
        _this4.currentPage = 1;
        console.log("router", _this4.router_sessions);
      });
    },
    createRouter: function createRouter() {
      var _this5 = this;
      var formElement = this.$refs.form2;
      console.log("form:", formElement.validate());
      if (!formElement.validate()) return;
      whitelistService.add_update_router(this.router_aux).then(function (response) {
        if (response.success === true) {
          _this5.$refs[_this5.DIALOG_ROUTER].onClose();
          tasks.toast.success("Correcto");
          _this5.getRouter();
        }
      }, function (err) {
        _this5.$toast.warning("Error");
      });
    },
    editWhitelist: function editWhitelist(item) {
      this.edit_whitelist = true;
      this.whitelist_aux = {
        domain: item.domain,
        domains_optional: item.domains_optional,
        email: item.email
      };
      this.$refs[this.DIALOG_WHITELIST].onOpen();
    },
    deleteWhitelist: function deleteWhitelist(item) {
      var _this6 = this;
      whitelistService.delete(item).then(function (response) {
        if (response.success === true) {
          //this.$refs[this.DIALOG_WHITELIST].onClose()
          tasks.toast.success("Eliminado correctamente");
          _this6.getWhitelist();
        }
      }, function (err) {
        _this6.$toast.warning("Error");
      });
    },
    deleteWhitelistAd: function deleteWhitelistAd(item) {
      var _this7 = this;
      whitelistService.delete_ad(item).then(function (response) {
        if (response.success === true) {
          tasks.toast.success("Eliminado correctamente");
          _this7.getWhitelistAd();
        }
      }, function (err) {
        _this7.$toast.warning("Error");
      });
    },
    openDialog: function openDialog() {
      this.edit_whitelist = false;
      this.whitelist_aux = {};
      this.$refs[this.DIALOG_WHITELIST].onOpen();
    },
    openDialog3: function openDialog3() {
      this.whitelist_ad_aux = [];
      this.$refs[this.DIALOG_WHITELIST_AD].onOpen();
    },
    openDialog2: function openDialog2(item, tipo) {
      console.log(tipo);
      this.router_aux = {};
      if (tipo == 'editar') {
        this.router_aux = Object.assign({}, item);
      }
      this.$refs[this.DIALOG_ROUTER].onOpen();
    },
    createWhitelist: function createWhitelist() {
      var _this8 = this;
      if (!this.edit_whitelist) {
        if (this.select_whitelist.filter(function (x) {
          return x.email.toLowerCase() === _this8.whitelist_aux.email.toLowerCase();
        }).length > 0) {
          tasks.toast.warning("El email ya existe en la lista blanca debe actualizarlo.");
          return;
        }
      }
      var formElement = this.$refs.form;
      console.log("form:", formElement.validate());
      if (!formElement.validate()) return;
      var data = {
        values: {
          "email": this.whitelist_aux.email,
          "domain": this.whitelist_aux.domain,
          "delete": false,
          "creator": window.userInfo.email,
          "domains_optional": this.whitelist_aux.domains_optional || []
        }
      };
      whitelistService.create(data).then(function (response) {
        if (response.success === true) {
          _this8.$refs[_this8.DIALOG_WHITELIST].onClose();
          tasks.toast.success("Creado correctamente");
          _this8.whitelist_aux = [];
          _this8.getWhitelist();
        }
      }, function (err) {
        _this8.$toast.warning("Error");
      });
    },
    createWhitelistAd: function createWhitelistAd() {
      var _this9 = this;
      var formElement = this.$refs.form3;
      if (!formElement.validate()) return;
      var data = {
        values: {
          "email": this.whitelist_ad_aux.email,
          "ad": this.whitelist_ad_aux.ad,
          "delete": false,
          "creator": window.userInfo.email
        }
      };
      whitelistService.create_ad(data).then(function (response) {
        if (response.success === true) {
          _this9.$refs[_this9.DIALOG_WHITELIST_AD].onClose();
          tasks.toast.success("Creado correctamente");
          _this9.whitelist_ad_aux = [];
          _this9.getWhitelistAd();
        }
      }, function (err) {
        _this9.$toast.warning("Error");
      });
    },
    getOrganizations: function getOrganizations() {
      var _this0 = this;
      domainService.getOrganizations().then(function (response) {
        var orgs = response.data;
        orgs.forEach(function (org) {
          _this0.selectOrganization.push(org);
        });
      });
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this1 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this1.list_orgs = response.data;
        }
      });
    }
    /*openDomain(item, tipo){
      this.domain_aux=item
      this.tipo=tipo
      console.log(this.domain_aux.list_orgs)
      this.$refs[this.DIALOG_DOMAIN].onOpen()
    },
    getOrganizations() {
      domainService.getOrganizations().then(response => {
        const orgs = response.data
        orgs.forEach(org => {
          this.selectOrganization.push(org)
        })
      })
    },
    updateDomain(){
      console.log("sending:", this.domain_aux)
      domainService.update_domain(this.domain_aux).then(response => {
          if(response.success === true){
            this.$refs[this.DIALOG_DOMAIN].onClose()
            this.getDomains()
          }
        }, err => {
          this.$toast.warning("Error")
        })
    }
    */
  }
}, "created", function created() {
  this.getWhitelist();
  this.getWhitelistAd();
  this.getOrganizations();
  this.getRouter();
  this.getListOrgsDetailed();
}), "computed", {
  headers: function headers() {
    return [{
      value: 'email',
      text: this.traductor("form_profile.email")
    }, {
      value: 'domain',
      text: this.traductor("tablas.organization"),
      align: "center"
    }, {
      value: 'creationDate',
      text: "Fecha de creación",
      align: "center"
    }, {
      value: 'creator',
      text: "Creador",
      align: "center"
    }, {
      value: 'actions',
      text: this.traductor("tablas.actions"),
      align: "center"
    }];
  },
  headers2: function headers2() {
    return [{
      value: 'id',
      text: this.traductor("tablas.organization")
    }, {
      value: 'domain',
      text: this.traductor("tablas.dominio_empresa"),
      align: "center"
    }, {
      value: 'active',
      text: this.traductor("tablas.status"),
      align: "center"
    }, {
      value: 'actions',
      text: this.traductor("tablas.actions"),
      align: "center"
    }];
  },
  headers3: function headers3() {
    return [{
      value: 'email',
      text: this.traductor("form_profile.email")
    }, {
      value: 'ad',
      text: "Tipo de AD",
      align: "center"
    }, {
      value: 'creationDate',
      text: "Fecha de creación",
      align: "center"
    }, {
      value: 'creator',
      text: "Creador",
      align: "center"
    }, {
      value: 'actions',
      text: this.traductor("tablas.actions"),
      align: "center"
    }];
  },
  getClassTable: function getClassTable() {
    if (this.filter_enabled) {
      return 'col-md-9 col-sm-12';
    } else {
      return 'col-sm-12';
    }
  }
});